import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Card,
} from '@mui/material';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainingCompanyEditRoutes";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MKButton from "components/MKButton";
import { LocationOn } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import { useNavigate } from 'react-router-dom';
import '../../../styles.css';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const Page = () => {
  // const styles = {
  //   gridItem: {
  //     border: '1px double #ccc',
  //     borderRadius: '30px',
  //     padding: '16px',
  //     marginBottom: '16px',
  //     boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  //     width: '500px',
  //     backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.0), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
  //   },
  //   trainingInfo: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //   },
  //   trainingName: {
  //     // marginTop: '10px',
  //     marginBottom: '8px',
  //     fontSize: 'medium',
  //     color: 'rgb(60, 150, 190)',
  //   },
  //   gridContent: {
  //     padding: '8px',
  //   },
  // };
  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
  const [activeTrainingDetails, setActiveTrainingDetails] = useState([]);
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [postedTrainingDetails, setPostedTrainingDetails] = useState([]);
  const [appliedTrainingDetails, setAppliedTrainingDetails] = useState([]);
  const [completedTrainingDetails, setCompletedTrainingDetails] = useState([]);
  const [expectedNewPaymentDate, setExpectedNewPaymentDate] = useState('');
  const [paymentNotReceivedModal, setPaymentNotReceivedModal] = useState(false);
  const [trainerWithStatus6Modal, setTrainerWithStatus6Modal] = useState(false);
  const [trainerWithStatus7Modal, setTrainerWithStatus7Modal] = useState(false);
  const [paymentExceededModal, setPaymentExceededModal] = useState(false);
  const [waitingTrainingConfirmation, setWaitingTrainingConfirmation] = useState(false);
  const [trainerStatus12, setTrainerStatus12] = useState([]);
  const [trainerStatus20, setTrainerStatus20] = useState([]);
  const [trainerExceededPayment, setTrainerExceededPayment] = useState([]);
  const [trainerWithStatus6, setTrainerWithStatus6] = useState([]);
  const [trainerWithStatus7, setTrainerWithStatus7] = useState([]);
  const [trainerWithStatus1, setTrainerWithStatus1] = useState([]);
  const [trainerStatus1, setTrainerStatus1] = useState(false);
  const [trainerWithStatus3, setTrainerWithStatus3] = useState([]);
  const [trainerStatus3, setTrainerStatus3] = useState(false);
  const [trainerWithStatus4, setTrainerWithStatus4] = useState([]);
  const [trainerWithStatus9, setTrainerWithStatus9] = useState([]);
  const [trainerWithStatus9Modal, setTrainerWithStatus9Modal] = useState(false);
  const [trainerStatus4, setTrainerStatus4] = useState(false);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.exists === false) {
          setTrainingCompanyProfileCreate(true);
          window.location.href = "/app/trainingcompanyprofile";
        } else {
          setTrainingCompanyProfileCreate(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);
  console.log("trainingCompanyProfileCreate", trainingCompanyProfileCreate);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard"
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-active-training-pending/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          const trainingArray = Array.isArray(data) ? data : [];
          setActiveTrainingDetails(trainingArray);

          let appliedTrainingArray = [];
          let completedTrainingArray = [];

          trainingArray.forEach((training) => {
            fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${training.id}/`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
              },
            })
              .then((resp) => resp.json())
              .then((trainerData) => {
                if (trainerData.length === 0) {
                  setPostedTrainingDetails((prevDetails) => [...prevDetails, training]);
                } else {
                  if (training.status === "11") {
                    setCompletedTrainingDetails((prevDetails) => [...prevDetails, training]);
                  } else {
                    setAppliedTrainingDetails((prevDetails) => [...prevDetails, training]);
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);

  const [cancelledTrainingDetails, setCancelledTrainingDetails] = useState([]);

  // useEffect(() => {
  //   let id = localStorage.getItem("userId");
  //   console.log(id);
  //   let display = "card";
  //   fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-active-training/${id}/${display}`, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + localStorage.getItem('token'),
  //     },
  //   })
  //     .then((resp) => resp.json())
  //     .then((data) => {
  //       console.log("data111111122222222222", data);
  //       const trainingArray = Array.isArray(data) ? data : [];
  //       setActiveTrainingDetails(trainingArray);

  //       if (data && data[0] && data[0].apply_data && data[0].apply_data.length > 0) {
  //         data[0].apply_data.forEach((applyTrainings) => {
  //           setAppliedTrainingDetails((prevDetails) => [...prevDetails, applyTrainings]);
  //         })
  //       }

  //       if (data && data[0] && data[0].completed_training_data && data[0].completed_training_data.length > 0) {
  //         data[0].completed_training_data.forEach((completed_trainings) => {
  //           setCompletedTrainingDetails((prevDetails) => [...prevDetails, completed_trainings]);
  //         })
  //       }

  //       if (data && data[0] && data[0].canceled_training_array && data[0].canceled_training_array.length > 0) {
  //         data[0].canceled_training_array.forEach((cancelled_trainings) => {
  //           setCancelledTrainingDetails((prevDetails) => [...prevDetails, cancelled_trainings]);
  //         })
  //       }

  //       if (data && data[0] && data[0].posted_training_array && data[0].posted_training_array.length > 0) {
  //         data[0].posted_training_array.forEach((posted_trainings) => {
  //           setPostedTrainingDetails((prevDetails) => [...prevDetails, posted_trainings]);
  //         })
  //       }

  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, [localStorage.getItem("userId")]);


  console.log("postedTrainingDetails", postedTrainingDetails);
  console.log("appliedTrainingDetails", appliedTrainingDetails);
  console.log("cancelledTrainingDetails", cancelledTrainingDetails);
  console.log("completedTrainingDetails", completedTrainingDetails);

  console.log("activeTrainingDetails", activeTrainingDetails);

  useEffect(() => {
    const fetchData = async (trainingID) => {
      try {
        const [activeTrainerListResp, singleTrainingDataResp] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${trainingID}/`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          }).then((resp) => resp.json()),
          fetch(`${process.env.REACT_APP_API_URL}/api/single-training-more-details/${trainingID}/`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          }).then((resp) => resp.json()),
        ]);

        const { detail: activeTrainerListDetail } = activeTrainerListResp;
        const { detail: singleTrainingDataDetail } = singleTrainingDataResp;

        if (activeTrainerListDetail && singleTrainingDataDetail) {
          return;
        }

        setTrainingDetails(singleTrainingDataResp);

        console.log("singleTrainingDataResp", singleTrainingDataResp);

        const trainerWithStatus12 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            [10, 17, 18].includes(parseInt(trainer.apply_training.previousStatus)) &&
            (!singleTrainingDataResp.expectedPaymentDate1 ||
              !singleTrainingDataResp.expectedPaymentDate2 ||
              !singleTrainingDataResp.expectedPaymentDate3)
        );

        const trainerMustSubmitProof = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 10 &&
            parseInt(trainer.apply_training.previousStatus) === 19 &&
            singleTrainingDataResp.expectedPaymentDate1 &&
            singleTrainingDataResp.expectedPaymentDate2 &&
            singleTrainingDataResp.expectedPaymentDate3
        );

        const trainerNotReceivedPayment = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            parseInt(trainer.apply_training.previousStatus) === 20 &&
            singleTrainingDataResp.expectedPaymentDate1 &&
            singleTrainingDataResp.expectedPaymentDate2 &&
            singleTrainingDataResp.expectedPaymentDate3
        );

        const trainerExceededLastPaymentDate = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
          parseInt(trainer.apply_training.previousStatus) === 19
        );

        const trainerWithStatus20 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 20
        );

        const todayDate = new Date().toISOString().split('T')[0];

        const trainerWithStatus6 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 6 &&
          new Date(todayDate) >= new Date(singleTrainingDataResp.trainingStartDate)
        );

        const trainerWithStatus7 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 7 &&
          new Date(todayDate) >= new Date(singleTrainingDataResp.trainingEndDate)
        );

        const trainerWithStatus9 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 9 &&
            parseInt(trainer.apply_training.previousStatus) === 8 &&
            new Date(todayDate) >= new Date(singleTrainingDataResp.expectedPaymentDate)
        );

        const trainerWithStatus1 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 1);

        const trainerWithStatus3 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 3);

        const trainerWithStatus4 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 4);

        if (trainerWithStatus1) {
          setTrainerStatus1(true);
          setTrainerWithStatus1((prev) => [...prev, singleTrainingDataResp]);
        }

        if (trainerWithStatus3) {
          setTrainerStatus3(true);
          setTrainerWithStatus3((prev) => [...prev, singleTrainingDataResp]);
        }

        if (trainerWithStatus4) {
          setTrainerStatus4(true);
          setTrainerWithStatus4((prev) => [...prev, singleTrainingDataResp]);
        }

        if (trainerWithStatus9) {
          console.log("trainerWithStatus9", trainerWithStatus9);
          setTrainerWithStatus9Modal(true);
          setTrainerWithStatus9((prev) => [...prev, trainerWithStatus9]);
        }

        if (trainerWithStatus12) {
          setPaymentNotReceivedModal(true);
          setTrainerStatus12((prev) => [...prev, trainerWithStatus12]);
        }

        if (trainerMustSubmitProof) {
          setPaymentExceededModal(true);
          setTrainerExceededPayment((prev) => [...prev, trainerMustSubmitProof]);
        }

        if (trainerNotReceivedPayment) {
          console.log("trainerNotReceivedPayment", trainerNotReceivedPayment);
          setPaymentExceededModal(true);
          setTrainerExceededPayment((prev) => [...prev, trainerNotReceivedPayment]);
        }

        if (trainerExceededLastPaymentDate) {
          console.log("trainerExceededLastPaymentDate", trainerExceededLastPaymentDate);
          setPaymentExceededModal(true);
          setTrainerExceededPayment((prev) => [...prev, trainerExceededLastPaymentDate]);
        }

        if (trainerWithStatus20) {
          console.log("trainerWithStatus20", trainerWithStatus20);
          setWaitingTrainingConfirmation(true);
          setTrainerStatus20((prev) => [...prev, trainerWithStatus20]);
        }

        if (trainerWithStatus6) {
          console.log("trainerWithStatus6", trainerWithStatus6);
          setTrainerWithStatus6Modal(true);
          setTrainerWithStatus6(trainerWithStatus6);
        }

        if (trainerWithStatus7) {
          console.log("trainerWithStatus7", trainerWithStatus7);
          setTrainerWithStatus7Modal(true);
          setTrainerWithStatus7(trainerWithStatus7);
        }

      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    activeTrainingDetails.forEach((training) => {
      fetchData(training.id);
    });
  }, [activeTrainingDetails]);

  console.log("trainerStatus3", trainerStatus3);
  console.log("trainerWithStatus3", trainerWithStatus3);

  console.log("trainerStatus4", trainerStatus4);
  console.log("trainerWithStatus4", trainerWithStatus4);

  const navigate = useNavigate();

  const onAppliedMoreDetailsClick = (training) => {
    console.log("training", training.id);
    navigate(`/app/activetrainingmoredetails/${training.id}/`);
  };

  const renderTrainerCards = (trainers, onClickHandler) => {
    return trainers.map((trainer, index) => (
      <Grid item xs={6} key={trainer.id} >
        <div className="gridItemSeeMore">
          <div className="gridContentSeeMore">
            <div className="trainingInfo">
              <Typography variant="subtitle1" className="trainingNameSeeMore"><strong>{trainer.trainingName}</strong></Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> 
                  {/* {trainer.technology} */}
                  {trainer.technology.length > 50 ? `${trainer.technology.substring(0, 50)}...` : trainer.technology}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{trainer.trainingCompanyName}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOn style={{ marginRight: '5px' }} /> {trainer.trainingMode}
                  {trainer.trainingMode === 'Classroom' ? ` | ${trainer.trainingLocations}` : ''}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {trainer.currency}&nbsp;{trainer.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {trainer.trainingExpectation}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <CalendarMonthIcon style={{ marginRight: '5px' }} /> {trainer.expectedStartDate}
                </span>
              </Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <Typography style={{ fontSize: 'medium' }}>
                Click on Respond button to Complete your action&nbsp;&nbsp;
              </Typography>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onClickHandler(trainer)} style={{ padding: '5px 10px' }}>Respond</MKButton>
            </div>
          </div>
        </div>
      </Grid>
    ));
  };


  return (
    <>
      <IdleTimeOutHandler />
      <DefaultNavbar
        routes={trainingCompanyProfileCreate ? routes : editRoutes}
        sticky
      />
      <Card
        sx={{
          minHeight: '101vh',
          height: 'auto',
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container>
            <Grid item xs={12} style={{ marginTop: "150px" }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                      <span style={{ color: 'black' }}>Pending</span>{' '}
                      <span style={{ color: '#2e1114' }}>Actions</span>
                    </MKTypography>
                  </Grid>
                </Grid>
                {trainerWithStatus1.length === 0 && trainerWithStatus3.length === 0 && trainerWithStatus4.length === 0 ? (
                  <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>There are no pending actions</span>
                ) : (
                  ""
                )}

                {trainerWithStatus1.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerWithStatus1, onAppliedMoreDetailsClick)}
                  </Grid>
                )}

                {trainerWithStatus3.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerWithStatus3, onAppliedMoreDetailsClick)}
                  </Grid>
                )}

                {trainerWithStatus4.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerWithStatus4, onAppliedMoreDetailsClick)}
                  </Grid>
                )}

              </div>
            </Grid>
          </Grid>
        </Container>
      </Card>
    </>
  );
};

export default Page;